import React, { useState, useEffect } from "react";
import { NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SERVER_PATH } from "../../config/env";
import './style.css'
import apiClient from "../../utils/api";

export default function NavData() {
  const [data, setData] = useState([]);

  const fetchData = () => {
    apiClient.post(`get/active_products.php`, {}).then((res) => {
      //all_product
      setData(res.data);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const herbalProducts = HerbalProducts();

  function HerbalProducts() {
    const arr = [];
    for (let i = 0; i < data.length; i++) {
      if (data?.[i]?.category === "health")
        arr.push({
          productId: data?.[i]?.product_id,
          productName: data?.[i]?.product_name,
        });
    }
    return arr;
  }

  const gardenProducts = GardenProducts();

  function GardenProducts() {
    const arr = [];
    for (let i = 0; i < data.length; i++) {
      if (data?.[i]?.category === "loss")
        arr.push({
          productId: data?.[i]?.product_id,
          productName: data?.[i]?.product_name,
        });
    }
    return arr;
  }

  const yogaProducts = YogaProducts();

  function YogaProducts() {
    const arr = [];
    for (let i = 0; i < data.length; i++) {
      if (data?.[i]?.category === "gain")
        arr.push({
          productId: data?.[i]?.product_id,
          productName: data?.[i]?.product_name,
        });
    }
    return arr;
  }

  const spices = Spices();

  function Spices() {
    const arr = [];
    for (let i = 0; i < data.length; i++) {
      if (data?.[i]?.category === "pickle")
        arr.push({
          productId: data?.[i]?.product_id,
          productName: data?.[i]?.product_name,
        });
    }
    return arr;
  }

  const foodProducts = FoodProducts();

  function FoodProducts() {
    const arr = [];
    for (let i = 0; i < data.length; i++) {
      if (data?.[i]?.category === "others")
        arr.push({
          productId: data?.[i]?.product_id,
          productName: data?.[i]?.product_name,
        });
    }
    return arr;
  }

  const dropDown = [
    {
      title: "Healthy Mix",
      dropDownTitle: herbalProducts,
    },
    {
      title: " Weight Loss",
      dropDownTitle: gardenProducts,
    },
    {
      title: "Weight Gain",
      dropDownTitle: yogaProducts,
    },
    {
      title: "Pickle",
      dropDownTitle: spices,
    },
    // {
    //   title: "Thanjavur Art",
    //   dropDownTitle: foodProducts,
    // },
    {
      title: "Others",
      dropDownTitle: foodProducts,
    },
  ];

  return (
    <>
      {dropDown.map((data, index) => (
        <li className="nav-item" key={index + "dropdown"} >
          <NavDropdown
        
            title={data.title}
            id="basic-nav-dropdown"
            className="custom-dropdown" // Add custom class here
          >
            {data.dropDownTitle.map((d, i) => (
              <NavDropdown.Item
                style={{ fontWeight: "400" }}
                as={Link}
                to={`/product/${d.productId}`}
                key={i + "dropdownItem"}
              >
                {d.productName}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        </li>
      ))}
    </>
  );
}

